import { render, staticRenderFns } from "./ItemsRentForRecalculatePrice.vue?vue&type=template&id=f4978410&scoped=true&"
import script from "./ItemsRentForRecalculatePrice.vue?vue&type=script&lang=js&"
export * from "./ItemsRentForRecalculatePrice.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentForRecalculatePrice.vue?vue&type=style&index=0&id=f4978410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4978410",
  null
  
)

export default component.exports